var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.414 10.117c0 .16.07.322.193.44l3.545 3.54a.596.596 0 00.424.182c.339 0 .586-.241.586-.569a.57.57 0 00-.178-.424L5.776 12.06l-1.558-1.423 1.252.075h6.51c.354 0 .601-.247.601-.596a.575.575 0 00-.601-.602H5.47l-1.246.075 1.552-1.423 1.208-1.225a.57.57 0 00.178-.424c0-.328-.247-.57-.586-.57-.156 0-.3.06-.44.194l-3.53 3.529a.619.619 0 00-.192.446zM10 2.45a.55.55 0 100 1.1v-1.1zm0 14a.55.55 0 100 1.1v-1.1zm0-12.9h4v-1.1h-4v1.1zM15.45 5v10h1.1V5h-1.1zM14 16.45h-4v1.1h4v-1.1zM15.45 15c0 .8-.65 1.45-1.45 1.45v1.1A2.55 2.55 0 0016.55 15h-1.1zM14 3.55c.8 0 1.45.65 1.45 1.45h1.1A2.55 2.55 0 0014 2.45v1.1z",
    fill: "currentColor"
  })));
}

export default SvgLeave;